export default __webpack_public_path__ + "static/media/cm.6b06a588.svg";